export class ScpCrossingAuditModel{
    
    audit:any[];
    wms:any[];

    constructor(){}
}